<script>
import baseList from '@/views/components/base/baseList.vue'
import { Button } from 'view-design'
export default {
  extends: baseList,
  components: {},
  data() {
    return {
      table: {
        mname: 'ReverbHelp',
        key: 'help_id',
        url: {},
        output: false,
      },
      menus: [
        {
          label: '回声树列表',
          name: 'reverb_list',
          auth: '/admin/reverb/lists',
          // badge: { mname: "statisticsstats", scene: "recycle_notverify" },
        },
        {
          label: '助力列表',
          name: 'reverb_info',
          auth: '/admin/reverbHelp/lists',
        },
        {
          label: '成员列表',
          name: 'reverbBound_list',
          auth: '/admin/reverbBound/lists',
          // badge: { mname: "statisticsstats", scene: "recycle_notverify" },
        },
      ],
      actions: [
        // {
        //   label: "创建",
        //   icon: "md-add",
        //   onClick: this.toAdd,
        //   auth: "/admin/reverb/add",
        // },
      ],
      tactions: [
        // { label: '导出数据', type: 'success', onClick: this.exportData.bind(this, '商家数据', 0), auth: '/admin/spot/lists' },
        // { label: '导出全部数据', type: 'error', onClick: this.exportData.bind(this, '商家数据', 1), auth: '/admin/spot/lists' },
      ],
      query: {
        reverb_id: this.$route?.query?.qv,
      },
      currentRow: null,
      filters: [
        { label: '助力人', name: 'user_nick', value: '', type: 'input' },
        { label: '回声树名称', name: 'tree_title', value: '', type: 'input' },
      ],
      tableCols: [
        {
          title: "ID",
          width: 80,
          key: "help_id",
        },
        {
          title: '助力人',
          key: 'user_name',
          width: 150,
        },
        {
          title: '助力目标',
          minWidth: 120,
          key: 'objective',
        },

        {
          title: 'KPI',
          minWidth: 300,
          key: 'kpi',
        },
        {
          title: '回声树',
          minWidth: 100,
          key: 'reverb_name',
        },
        {
          title: '状态',
          align: 'center',
          key: 'status',
          minWidth: 100,
          switch: true,
          disabled: false,
        },
        {
          title: '助力时间',
          minWidth: 120,
          key: 'create_time',
        },
        {
          title: '操作',
          align: 'center',
          minWidth: 150,
          key: 'handle',
          fixed: 'right',
          handle: ['delete'],
          auth: {
            del: '/admin/reverbHelp/del',
          },
        },
      ],
    }
  },
  created() {},

  methods: {
    toAdd() {
      $utils.url.push({
        name: 'show_add',
        query: {
          action: 'add',
        },
      })
    },
    Detail(row) {
      this.$Modal.info({
        title: row.objective,
        // width: 1000,
        render: () => (
          <div>
            <p>{row.detail}</p>
          </div>
        ),
      })
    },
  },
}
</script>
